import { gsap, ScrollTrigger } from '../global/gsap';
import vars from '../global/vars';

const initFooter = (container) => {
    const logo = container.querySelector('svg');
    if (!logo) return;

    const logoPaths = logo.querySelectorAll('path');

    const footerTl = gsap.timeline({
        scrollTrigger: {
            trigger: logo,
            start: 'top 80%',
        }
    });

    gsap.set(logoPaths, {
        autoAlpha: 0,
        yPercent: 100
    });

    footerTl.to(logoPaths, {
        autoAlpha: 1,
        yPercent: 0,
        duration: 0.4,
        stagger: 0.1,
        ease: 'power2.inOut'
    });
};

export default initFooter;
